import { render } from "./SectionListManager.vue?vue&type=template&id=b6b038a8"
import script from "./SectionListManager.vue?vue&type=script&lang=js"
export * from "./SectionListManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__